export const ACCOUNT_TYPE = {
  PARENT: "parent"
};

export const CREATE_NEW_USER = 'manageUser.createNewUser';

export const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

export const ORDER_TYPE_CONFIG = {
  Standard: {
    title: 'registration.orderTypes.place-Orders',
    permissionChecks: [
      { key: 'AUTH_HME_ORDER', value: 'Y' },
      { key: 'IS_ACTIVE_HME', value: 'IS_ACTIVE_HME' },
    ],
    activeKeys: ['IS_ACTIVE_HME'],
  },

  'Standard View Only': {
    title: 'registration.orderTypes.place-Orders-View-Only',
    permissionChecks: [
      { key: 'AUTH_HME_VIEW_ONLY_ORDER', value: 'Y' },
      { key: 'IS_ACTIVE_HME_VIEW_ONLY', value: 'Y' },
    ],
    activeKeys: ['IS_ACTIVE_HME_VIEW_ONLY'],
  },

  'Standard Priceless': {
    title: 'registration.orderTypes.place-Orders-no-price-visibility',
    permissionChecks: [
      { key: 'AUTH_STANDARD_PRICELESS', value: 'Y' },
      { key: 'IS_ACTIVE_STANDARD_PRICELESS', value: 'Y' },
    ],
    activeKeys: [
      'IS_ACTIVE_STANDARD_PRICELESS',
      'AUTH_STANDARD_PRICELESS',
    ],
  },

  CreditClaimDVA: {
    title: 'registration.orderTypes.credit-claim-dva',
    permissionChecks: [
      { key: 'AUTH_CREDIT_CLAIM_DVA', value: 'Y' },
      { key: 'IS_ACTIVE_CREDIT_CLAIM_DVA', value: 'Y' },
    ],
    activeKeys: [
      'IS_ACTIVE_CREDIT_CLAIM_DVA',
      'AUTH_CREDIT_CLAIM_DVA',
    ],
  },

  CareLink: {
    title: 'registration.orderTypes.carelink',
    permissionChecks: [
      { key: 'AUTH_CARELINK_ORDER', value: 'Y' },
      { key: 'IS_ACTIVE_CARELINK', value: 'Y' },
    ],
    activeKeys: ['IS_ACTIVE_CARELINK', 'AUTH_CARELINK_ORDER'],
    isANZOnly: true,
  },

  ServiceRequest: {
    title: 'registration.orderTypes.service-request',
    permissionChecks: [
      { key: 'AUTH_SERVICE_REQUEST', value: 'Y' },
      { key: 'IS_ACTIVE_SERVICE_REQUEST', value: 'Y' },
    ],
    activeKeys: [
      'IS_ACTIVE_SERVICE_REQUEST',
      'AUTH_SERVICE_REQUEST',
    ],
    isANZOnly: true,
  },

  'Warranty LookUp': {
    title: 'registration.orderTypes.warranty-LookUp',
    permissionChecks: [
      { key: 'AUTH_WARRANTY_LOOKUP', value: 'Y' },
      { key: 'IS_ACTIVE_WARRANTY_LOOKUP', value: 'Y' },
    ],
    activeKeys: [
      'IS_ACTIVE_WARRANTY_LOOKUP',
      'AUTH_WARRANTY_LOOKUP',
    ],
  },

  'Mask-Guarantee': {
    title: 'registration.orderTypes.mask-Guarantee',
    permissionChecks: [
      { key: 'AUTH_MG_ORDER', value: 'Y' },
      { key: 'IS_ACTIVE_MG', value: 'Y' },
    ],
    activeKeys: ['IS_ACTIVE_MG'],
  },

  'Sleep-Lab': {
    title: 'registration.orderTypes.sleep-Lab-Mask-Ordering',
    permissionChecks: [
      { key: 'AUTH_RSVP_ORDER', value: 'Y' },
      { key: 'IS_ACTIVE_RSVP', value: 'Y' },
    ],
    activeKeys: ['IS_ACTIVE_RSVP'],
  },

  'Drop-Ship': {
    title: 'registration.orderTypes.dropship-Masks-and-Accessories-Only',
    permissionChecks: [
      { key: 'AUTH_DS_ORDER', value: 'Y' },
      { key: 'IS_ACTIVE_DS', value: 'Y' },
    ],
    activeKeys: ['IS_ACTIVE_DS'],
  },

  Payments: {
    title: 'registration.orderTypes.online-Bill-Payment',
    permissionChecks: [
      { key: 'AUTH_ONLINE_BILL', value: 'Y' },
      { key: 'IS_ACTIVE_ONLINE_BILL', value: 'Y' },
    ],
    activeKeys: ['IS_ACTIVE_ONLINE_BILL'],
  },

  'RMA View Only': {
    title: 'registration.orderTypes.product-Returns-View-Only',
    permissionChecks: [
      { key: 'AUTH_RMA_VIEW_ONLY_ORDER', value: 'Y' },
      { key: 'IS_ACTIVE_RMA_VIEW_ONLY', value: 'Y' },
    ],
    activeKeys: ['IS_ACTIVE_RMA_VIEW_ONLY'],
  },

  RMA: {
    title: 'registration.orderTypes.product-Returns',
    permissionChecks: [
      { key: 'AUTH_RMA', value: 'Y' },
      { key: 'IS_ACTIVE_RMA', value: 'Y' },
    ],
    activeKeys: ['IS_ACTIVE_RMA'],
  },
};